// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".classic-module[data-v-3bc6e5e5]{position:relative;transition:opacity .25s ease-in}.classic-module .headline[data-v-3bc6e5e5]{text-transform:none;color:#fff;font-size:28px;line-height:32px;font-weight:700;margin-block-end:24px;display:flex;justify-content:space-between;align-items:center}.classic-module .vertical[data-v-3bc6e5e5] .streaming-chart-list-item[data-position=\"10\"]:before{left:-28px;letter-spacing:-2px}", ""]);
// Exports
module.exports = exports;
